<!--<app-cosy-dynaeditor [viewAreaTemplateID]="viewAreaTemplateID"></app-cosy-dynaeditor>-->
<div *ngIf="(loadingToDisplay)" style="background-color: blueviolet">
  <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '0px' , fullScreenBackdrop : true,
    backdropBackgroundColour : 'rgba(0, 0, 0, 0.3)', animationType : ANIMATION_TYPES.threeBounce}"></ngx-loading>
</div>
<div [class]="classVA">
  <ng-container *ngTemplateOutlet="IEUISection;context:{IELIST: ieList}">
  </ng-container>
</div>
<ng-template #IEUISection let-interfaceElementList="IELIST">
  <ng-container  *ngFor="let ie of interfaceElementList">
    <ng-container *ngIf="(ie.Attributes.Visible == true)" >
      
      <app-cosy-autocomplete *ngIf="(ie.TypeDID == IE_TYPES.InputSearch)" [ie]="ie"
        [class]="ie.Attributes.AssignedColumnWidth == null ? 'col-md-12' : ie.Attributes.AssignedColumnWidth">
      </app-cosy-autocomplete>
      <app-cosy-appmap *ngIf="ie.TypeDID == IE_TYPES.AppMapPathSearch" [ie]="ie"
      [class]="ie.Attributes.AssignedColumnWidth == null ? 'col-md-12' : ie.Attributes.AssignedColumnWidth">
      </app-cosy-appmap>
      <app-cosy-inputtext *ngIf="(ie.TypeDID == IE_TYPES.InputText ) || (ie.TypeDID == IE_TYPES.InputNumber) ||
        (ie.TypeDID == IE_TYPES.InputDate)" [ie]="ie" [label]="true"
        [class]="ie.Attributes.AssignedColumnWidth == null ? 'col-md-2' : ie.Attributes.AssignedColumnWidth">
      </app-cosy-inputtext>
      <app-cosy-picklist *ngIf="(ie.TypeDID == IE_TYPES.InputPicklist || ie.TypeDID == IE_TYPES.LanguageSelector || ie.TypeDID == IE_TYPES.InputValuePicklist)"  [ie]="ie" [label]="true"
      [languageOptions]="languageOptions"  [class]="ie.Attributes.AssignedColumnWidth == null ? 'col-md-2' : ie.Attributes.AssignedColumnWidth">
      </app-cosy-picklist>
      <app-cosy-trigger  *ngIf="(ie.TypeDID == IE_TYPES.Trigger)" [ie]="ie"    (switchToApp)= "switchToAppChildAction($event)"
      [class]="ie.Attributes.AssignedColumnWidth == null ? 'col-md-2' : ie.Attributes.AssignedColumnWidth">
    </app-cosy-trigger>
      <app-cosy-label *ngIf="(ie.TypeDID == IE_TYPES.Label)" [ie]="ie" [breadCrumb]="breadCrumb"  (loadHistory)="loadHistorytoBreadCrumb($event)" 
        [class]="ie.Attributes.AssignedColumnWidth == null ? 'col-md-12' : ie.Attributes.AssignedColumnWidth"> 
      </app-cosy-label>
      <app-cosy-grid *ngIf="(ie.TypeDID == IE_TYPES.EntityList)"
        [ie]="ie"
        [class]="ie.Attributes.AssignedColumnWidth == null ? 'col-md-12' : ie.Attributes.AssignedColumnWidth">
      </app-cosy-grid>
      <app-cosy-menu *ngIf="(ie.TypeDID == IE_TYPES.MenuList || ie.TypeDID == IE_TYPES.CentralMenuList)" [ie]="ie"  (switchToApp)= "switchToAppAction($event)"
        [class]="ie.Attributes.AssignedColumnWidth"></app-cosy-menu>
      <app-cosy-checkbox  [class]="ie.Attributes.AssignedColumnWidth == null ? '' : ie.Attributes.AssignedColumnWidth" 
      *ngIf="(ie.TypeDID == IE_TYPES.InputBoolean)" [ie]="ie" [label]="true"></app-cosy-checkbox>
      <app-cosy-entity *ngIf="(ie.TypeDID == IE_TYPES.FormEntity)" [ieEntity]="ie"
        [class]="ie.Attributes.AssignedColumnWidth == null ? 'col-md-12' : 'col-md-12'"></app-cosy-entity>
      <app-cosy-form-control *ngIf="(ie.TypeDID == IE_TYPES.UXController || ie.TypeDID == IE_TYPES.ListUXController)"
        [ieCompleteList]="interfaceElementList" [ie]="ie" [downloadFile]="downloadFile" [sessionID]="sessionID" [isFromRibbon]="isFromRibbon"
        [class]="ie.Attributes.AssignedColumnWidth" [cosyFormInit]="cosyFormInit">
      </app-cosy-form-control>
      <app-cosy-wizard *ngIf="(ie.TypeDID == IE_TYPES.Wizard)" [ie]="ie"
        [class]="ie.Attributes.AssignedColumnWidth == null ? 'col-md-12' : ie.Attributes.AssignedColumnWidth">
      </app-cosy-wizard>
      <app-cosy-tree *ngIf="(ie.TypeDID == IE_TYPES.EntityTree || ie.TypeDID == IE_TYPES.CollectionTree)" [ie]="ie"
      [class]="'col-md-12'">
      </app-cosy-tree>
      <app-cosy-breadcrumb (loadHistory)="loadHistorytoBreadCrumb($event)"  *ngIf="(ie.TypeDID == IE_TYPES.BreadCrumb)" [ie]="ie"
        [class]="ie.Attributes.AssignedColumnWidth == null ? 'col-md-12' : ie.Attributes.AssignedColumnWidth"  [breadCrumb]="breadCrumb">
      </app-cosy-breadcrumb>
      <app-cosy-ribbon *ngIf="(ie.TypeDID == IE_TYPES.Ribbon)" [ie]="ie" [downloadFile]="downloadFile"  [ieCompleteList]="interfaceElementList" 
        [cosyFormInit]="cosyFormInit" [class]="ie.Attributes.AssignedColumnWidth == null ? 'col-md-12' : ie.Attributes.AssignedColumnWidth"  (loadHistory)="loadHistorytoBreadCrumb($event)">
      </app-cosy-ribbon>
      </ng-container>
  </ng-container>
</ng-template>